/**
 * @generated SignedSource<<485e3af7c67df2c3f2923c0d715417b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSwatchSelector_item$data = {
  readonly isRingItem: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"SwatchSelector_item">;
  readonly " $fragmentType": "PdpRespSwatchSelector_item";
};
export type PdpRespSwatchSelector_item$key = {
  readonly " $data"?: PdpRespSwatchSelector_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSwatchSelector_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSwatchSelector_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "shouldFetchBuyerInfo",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "SwatchSelector_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRingItem",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "5ff5ca83955f8a134ee9cf2073a72614";

export default node;
